export enum LocationTypeEnum {
  Plant = "P",
  Aggregates = "A",
  Depot = "D",
}
